import {
  FETCH_EDIDATA_REQUEST,
  FETCH_EDIDATA_SUCCESS,
  FETCH_EDIDATA_FAILURE,
} from "../actionTypes";

import edi from "../service/cbp";

const fetchEdiResponse = () => {
  return {
    type: FETCH_EDIDATA_REQUEST,
  };
};

const fetchEdiDataSuccess = (edidata) => {
  //alert(JSON.stringify(edidata))
  return {
    type: FETCH_EDIDATA_SUCCESS,
    payload: edidata,
  };
};

const fetchEdiDatafailure = (error) => {
  return {
    type: FETCH_EDIDATA_FAILURE,
    payload: error,
  };
};

export const fetchEdidata = (shipmentID, country, US_FORM_TYPE, isPscRequest) => {
  return (dispatch) => {
    dispatch(fetchEdiResponse());
    if(US_FORM_TYPE===true){
      edi.getCarmRecords()
      .then((response) => {
        const edidata = response.data;
        //alert(JSON.stringify(edidata));
        dispatch(fetchEdiDataSuccess(edidata));
      })
      .catch((error) => {
        const errorMessage = error.message;
        dispatch(fetchEdiDatafailure(errorMessage));
      });
    }
    else{
      edi
      .getCbpRequest(shipmentID, country, US_FORM_TYPE, isPscRequest)
      .then((response) => {
        const edidata = response.data;
        //alert(JSON.stringify(edidata));
        dispatch(fetchEdiDataSuccess(edidata));
      })
      .catch((error) => {
        const errorMessage = error.message;
        dispatch(fetchEdiDatafailure(errorMessage));
      });
    }
    
  };
};
